// extracted by mini-css-extract-plugin
module.exports = {"active":"_2L0PiBlYdIIv-gF-VJU8bi"};